import { call, put, select, takeEvery } from 'redux-saga/effects';
import { push, replace } from 'connected-react-router';
import { safe } from './util';
import { fetchResultList, fetchSingleResultList } from '../api/result-history';
import {
  addResultHistoryAction,
  appendResultHistoryListAction,
  FETCH_MORE_RESULT_HISTORY_SAGA, setEndState, setLoadingState,
  SHOW_RESULT_HISTORY_SAGA,
} from '../actions/result-history';

function* fetchMoreResultHistory() {
  const current = yield select(state => state.resultHistory.list);
  const currentArray = Object.values(current);
  let results;
  yield put(setLoadingState(true));
  if (currentArray.length) {
    results = yield call(fetchResultList, { pointer: currentArray[currentArray.length - 1].id });
  } else {
    results = yield call(fetchResultList);
  }
  yield put(setEndState(!results.data || !results.data.length || results.end));
  yield put(setLoadingState(false));
  yield put(appendResultHistoryListAction(results.data));
}

export function* watchResultHistoryList() {
  yield takeEvery(FETCH_MORE_RESULT_HISTORY_SAGA, safe(fetchMoreResultHistory));
}

function* showResultHistory({ id, replaceHistory = false }) {
  const current = yield select(state => state.resultHistory.records);

  try {
    if (!current[id]) {
      const result = yield call(fetchSingleResultList, { id });
      yield put.resolve(addResultHistoryAction(result));
    }
    if (replaceHistory) {
      yield put(replace(`/report/${id}`));
    } else {
      yield put(push(`/report/${id}`));
    }
  } catch (ex) {
    alert('指定的报告页面不存在。');
    yield put(replace('/history'));
  }
}

export function* watchResultHistory() {
  yield takeEvery(SHOW_RESULT_HISTORY_SAGA, safe(showResultHistory));
}



// WEBPACK FOOTER //
// ./src/sagas/result-history.js